export const Cross = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_610_12231)">
            <path d="M4.5 19.4996L19.4997 4.49969M4.50015 4.49985L19.4998 19.4998" stroke="#1F1F1F" strokeWidth="2" strokeLinecap="square"/>
            </g>
            <defs>
            <clipPath id="clip0_610_12231">
            <rect width="24" height="24" fill="white"/>
            </clipPath>
            </defs>
        </svg>
    );
  };